import { Suspense, useEffect, useState } from "react";
// libraries
import { Route, Routes as Router } from "react-router-dom";

import Onboarding from "../../components/onboarding";
import Login from "../../pages/authentication/login";
import Reset from "../../pages/authentication/reset";
import ContractsList from "../../pages/contract/list";
import ContractNotFound from "../../pages/contract/notFound";
// authenticated Routes
import Home from "../../pages/home";
import Payment from "../../pages/payment";
import User from "../../pages/user";
import UserProfile from "../../pages/userProfile";
import Wallets from "../../pages/wallets";
// constants
import { ROUTES } from "../constants";
import { isLoggedIn } from "../context/authContext";
import { EVENT_LOCAL_STORAGE_LOGIN } from "../context/events";
import ContractRoute from "../context/routes/contractRoutes";
import { PrivateRoute } from "../context/routes/privateRoutes";

const Routes = () => {
  const [isAuth, setIsAuth] = useState<boolean>(isLoggedIn);
  useEffect(() => {
    window.addEventListener(EVENT_LOCAL_STORAGE_LOGIN, () => {
      setIsAuth(isLoggedIn());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn()]);

  return (
    <Suspense fallback={<div />}>
      <Router>
        <Route path={ROUTES.HOME} element={isAuth ? <Home /> : <Login />} />
        <Route path={ROUTES.RESET} element={<Reset />} />
        <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
        <Route path={ROUTES.USER} element={<User />} />
        <Route
          path={ROUTES.CONTRACT_NOT_FOUND}
          element={<ContractNotFound />}
        />
        <Route path={ROUTES.CONTRACTS_LIST} element={<PrivateRoute />}>
          <Route path={ROUTES.CONTRACTS_LIST} element={<ContractsList />} />
        </Route>
        <Route path={ROUTES.HOME} element={<PrivateRoute />}>
          <Route path={ROUTES.PAYMENT} element={<Payment />} />
        </Route>
        <Route
          path={ROUTES.CONTRACT_DETAILS}
          element={<ContractRoute />}></Route>
        <Route path={ROUTES.HOME} element={<PrivateRoute />}>
          <Route path={ROUTES.PROFILE} element={<UserProfile />} />
        </Route>
        <Route path={ROUTES.PAYMENTS} element={<PrivateRoute />}>
          <Route path={ROUTES.PAYMENTS} element={<Wallets />} />
        </Route>
      </Router>
    </Suspense>
  );
};

export default Routes;
